module.exports = __webpack_public_path__ + "/bundle/asset/admission4-1-794e7635a2757175397511a6e800fddc.png";